"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var React = require("react");
var ReactModal = require("react-modal");
var styled_1 = require("../../styled");
var Header = styled_1.default.h5(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  font-weight: bold;\n"], ["\n  text-align: center;\n  font-weight: bold;\n"])));
var Footer = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var defaultContainerStyle = {
    maxHeight: '84vh',
};
var EnvirioModal = function (_a) {
    var className = _a.className, closeIcon = _a.closeIcon, containerStyle = _a.containerStyle, content = _a.content, footer = _a.footer, header = _a.header, isOpen = _a.isOpen, mountNode = _a.mountNode, _b = _a.overflowStyle, overflowStyle = _b === void 0 ? 'auto' : _b, style = _a.style, theme = _a.theme, toggle = _a.toggle;
    return (React.createElement(ReactModal, { ariaHideApp: false, isOpen: isOpen, onRequestClose: function (e) {
            e.stopPropagation();
            e.preventDefault();
        }, shouldCloseOnEsc: false, shouldCloseOnOverlayClick: true, style: {
            content: __assign({ borderRadius: '4px', margin: '0px auto', bottom: 'unset', display: 'flex', flexDirection: 'column', border: 'none', boxShadow: '0 4px 16px 0 rgba(0, 36, 45, 0.1)', overflow: overflowStyle, maxWidth: style && style.content && style.content.maxWidth
                    ? style.content.maxWidth
                    : '504px' }, (style && style.content ? style.content : {})),
            overlay: __assign({ zIndex: 1000, backgroundColor: 'rgba(0, 36, 45, 0.25)' }, (style && style.overlay ? style.overlay : {})),
        } },
        React.createElement("div", { style: __assign(__assign({}, defaultContainerStyle), containerStyle) },
            header && React.createElement(Header, null, header),
            content && content,
            footer && React.createElement(Footer, null, footer))));
};
var BaseEnvirioModal = styled_1.default(EnvirioModal)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
exports.Modal = styled_1.default(BaseEnvirioModal)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map